export class TaskCommentCreatedEvent {};
